import {builderManager, getDefaultBuilder, getBuilder} from './manager.js';

export const AUDIENCE_BUILDER_KEY = 'ab';

// For backward compatibility, export the default builder instance
export const audienceBuilder = getDefaultBuilder();

// Export the manager and utility functions for the new key-based approach
export {builderManager, getDefaultBuilder, getBuilder};
